import { CtaLink } from "../ui/CtaLink";
import { motion } from "framer-motion";
import { HeroScene } from "../three/HeroScene";
import { useI18n } from "../i18n";
import { LoopVideo } from "../ui/LoopVideo";
import bg from "../assets/1block_loop.mp4";

const USE_R3F_FALLBACK = true;

export function Hero() {
  const { t } = useI18n();
  return (
    <section className="relative min-h-[100vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        {bg ? (
          <LoopVideo src={bg} fadeMs={1200} />
        ) : USE_R3F_FALLBACK ? (
          <HeroScene />
        ) : null}
      </div>
      <div className="absolute inset-x-0 bottom-0 h-[60%] bg-gradient-to-t from-[var(--color-cream)] via-[var(--color-cream)]/40 to-transparent pointer-events-none" />

      <div className="relative z-10 max-w-3xl px-6 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          className="text-5xl md:text-6xl leading-[1.08] text-[var(--color-ink)]"
        >
          {t("hero.title")}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="mt-6 text-[var(--color-muted)] max-w-xl mx-auto"
        >
          {t("hero.sub")}
        </motion.p>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.35 }}
          className="mt-10 flex items-center justify-center gap-4 flex-wrap"
        >
          <CtaLink cta="waitlist" block="hero" to="/waitlist" className="pill-btn">{t("hero.cta.join")}</CtaLink>
          <CtaLink cta="survey" block="hero" to="/survey" className="pill-outline">{t("hero.cta.survey")}</CtaLink>
        </motion.div>
      </div>
    </section>
  );
}
